import React from "react";
import { Text, Icon } from "shared";
import { getDate } from "utils/time";
import { useTranslation } from "react-i18next";
import { Circle } from "assets";

interface DeletedProps {
  user: {
    deleted_at: string;
    id: number;
  };
}

const Deleted: React.VFC<DeletedProps> = ({ user }) => {
  const { t } = useTranslation();

  if (!user?.deleted_at) return null;

  return (
    <Text paragraph mb={0} data-testid="status">
      <Icon of={Circle} error size={0.7} aria-label="Inactive account" />
      <Text ml={1} bold>
        {user.id}
      </Text>
      <Text right>
        <Text light ml="auto">
          {t`patient.deleted`}:{" "}
        </Text>
        <Text bold mr={1}>
          {getDate(user.deleted_at as string)}
        </Text>
      </Text>
    </Text>
  );
};

export default Deleted;
